import React, { useState } from "react";
import styles from "./AddEnquiry.module.css";
import { FaUserPlus, FaUser, FaMale, FaFemale } from "react-icons/fa";

import HeadingAndIcon from "../../components/HeadingAndIcon/HeadingAndIcon";
import HeadingAndData from "../../components/HeadingAndData/HeadingAndData";
import HeadingAndDropDown from "../../components/HeadingAndDropDown/HeadingAndDropDown";
import SaveAndCancel from "../../components/SaveAndCancel/SaveAndCancel";
import ToClose from "../../components/ToClose/ToClose";
import RadioComponent from "../../components/RadioComponent/RadioComponent";
import CalendarInput from "../../components/CalendarInput/CalendarInput";

import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice";

const AddEnquiry = () => {
  const dispatch = useDispatch();

  const [studentName, setStudentName] = useState("");
  const [gender, setGender] = useState("Male");
  const [status, setStatus] = useState("");
  const [source, setSource] = useState("");
  const [dob, setDob] = useState("");
  const [school, setSchool] = useState("");
  const [program, setProgram] = useState("");
  const [address, setAddress] = useState("");
  const [emergencyContactName, setEmergencyContactName] = useState("");
  const [emergencyContactNo, setEmergencyContactNo] = useState("");
  const [createdOn, setCreatedOn] = useState("");
  const [nextFollowUp, setNextFollowUp] = useState("");
  const [expectedStart, setExpectedStart] = useState("");
  const [assignTo, setAssignTo] = useState("");
  const [notes, setNotes] = useState("");

  const [fatherName, setFatherName] = useState("");
  const [fatherMobile, setFatherMobile] = useState("");
  const [fatherEmail, setFatherEmail] = useState("");

  const [motherName, setMotherName] = useState("");
  const [motherMobile, setMotherMobile] = useState("");
  const [motherEmail, setMotherEmail] = useState("");

  return (
    <div className={styles.container}>
      <div className={styles.AddStudentModal}>
        <div className={styles.header}>
          <HeadingAndIcon icon={<FaUserPlus />} heading="Add Enquiry" />
          <ToClose onClose={() => dispatch(closeModal())} />
        </div>

        {/* === ENQUIRY SECTION === */}
        <SectionBox icon={<FaUser />} heading="Enquiry Details">
          <div className={styles.inputsRow}>
            <HeadingAndData
              label="Student Name"
              name="studentName"
              placeholder="Enter Student name"
              value={studentName}
              onChange={(e) =>
                /^[a-zA-Z\s]*$/.test(e.target.value) &&
                setStudentName(e.target.value)
              }
              required
            />
            <HeadingAndDropDown
              label="Status"
              name="status"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              options={[
                { label: "New", value: "new" },
                { label: "In Progress", value: "progress" },
                { label: "Closed", value: "closed" },
              ]}
              required
            />
            <div className={styles.radioGroup}>
              <span className={styles.radioLabel}>Gender *</span>
              <div className={styles.radioOptions}>
                {["Male", "Female"].map((g) => (
                  <RadioComponent
                    key={g}
                    name="gender"
                    value={g}
                    label={g}
                    checked={gender === g}
                    onChange={(e) => setGender(e.target.value)}
                  />
                ))}
              </div>
            </div>
          </div>

          <div className={styles.inputsRow}>
            <HeadingAndDropDown
              label="Source"
              name="source"
              value={source}
              onChange={(e) => setSource(e.target.value)}
              options={[
                { label: "Referral", value: "referral" },
                { label: "Online", value: "online" },
              ]}
            />
            <CalendarInput
              fieldLabel="Date of Birth"
              required
              value={dob}
              onChange={setDob}
            />
            <HeadingAndData
              label="School"
              placeholder="Enter your school name"
              value={school}
              onChange={(e) => setSchool(e.target.value)}
              required
            />
          </div>

          <div className={styles.inputsRow}>
            <HeadingAndDropDown
              label="Program"
              name="program"
              value={program}
              onChange={(e) => setProgram(e.target.value)}
              options={[
                { label: "Program A", value: "A" },
                { label: "Program B", value: "B" },
              ]}
            />
            <HeadingAndData
              label="Address"
              placeholder="Enter your address"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              required
            />
          </div>

          <div className={styles.inputsRow}>
            <HeadingAndData
              label="Emergency contact name"
              placeholder="Enter name"
              value={emergencyContactName}
              onChange={(e) => setEmergencyContactName(e.target.value)}
            />
            <HeadingAndData
              label="Emergency contact no"
              placeholder="Enter number"
              value={emergencyContactNo}
              onChange={(e) => setEmergencyContactNo(e.target.value)}
            />
            <CalendarInput
              fieldLabel="Created on"
              required
              value={createdOn}
              onChange={setCreatedOn}
            />
          </div>

          <div className={styles.inputsRow}>
            <CalendarInput
              fieldLabel="Next Follow up"
              required
              value={nextFollowUp}
              onChange={setNextFollowUp}
            />
            <CalendarInput
              fieldLabel="Expected Start date"
              required
              value={expectedStart}
              onChange={setExpectedStart}
            />
            <HeadingAndDropDown
              label="Assign to"
              name="assignto"
              placeholder="Choose staff"
              value={assignTo}
              onChange={(e) => setAssignTo(e.target.value)}
              options={[
                { label: "Staff A", value: "a" },
                { label: "Staff B", value: "b" },
              ]}
            />
          </div>

          <div className={styles.inputsRow}>
            <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
              <label
                htmlFor="additionalNotes"
                style={{ marginBottom: "0.5rem" }}
              >
                Additional Notes *
              </label>
              <textarea
                id="additionalNotes"
                rows={3}
                className={styles.additionalnotes}
                placeholder="Enter any notes"
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
              />
            </div>
          </div>

          <div className={styles.actionsRow}>
            <SaveAndCancel
              onSave={() => console.log("Enquiry Saved")}
              onCancel={() => console.log("Enquiry Cancelled")}
            />
          </div>
        </SectionBox>

        {/* === PARENT DETAILS SECTION === */}
        <div className={styles.detailsRow}>
          <SectionBox icon={<FaMale />} heading="Father Details">
            <HeadingAndData
              label="Father Name"
              name="fatherName"
              placeholder="Enter Father name"
              value={fatherName}
              onChange={(e) =>
                /^[a-zA-Z\s]*$/.test(e.target.value) &&
                setFatherName(e.target.value)
              }
              required
            />
            <HeadingAndData
              label="Father Mobile Number"
              name="fatherMobile"
              placeholder="Enter Mobile Number"
              value={fatherMobile}
              onChange={(e) =>
                /^\d{0,10}$/.test(e.target.value) &&
                setFatherMobile(e.target.value)
              }
              required
            />
            <HeadingAndData
              label="Father Email ID"
              name="fatherEmail"
              placeholder="Enter Email"
              type="email"
              value={fatherEmail}
              onChange={(e) => setFatherEmail(e.target.value)}
            />
            <SaveAndCancel
              onSave={() => console.log("Saved Father")}
              onCancel={() => console.log("Cancelled Father")}
            />
          </SectionBox>

          <SectionBox icon={<FaFemale />} heading="Mother Details">
            <HeadingAndData
              label="Mother Name"
              name="motherName"
              placeholder="Enter Mother name"
              value={motherName}
              onChange={(e) =>
                /^[a-zA-Z\s]*$/.test(e.target.value) &&
                setMotherName(e.target.value)
              }
              required
            />
            <HeadingAndData
              label="Mother Mobile Number"
              name="motherMobile"
              placeholder="Enter Mobile Number"
              value={motherMobile}
              onChange={(e) =>
                /^\d{0,10}$/.test(e.target.value) &&
                setMotherMobile(e.target.value)
              }
              required
            />
            <HeadingAndData
              label="Mother Email ID"
              name="motherEmail"
              placeholder="Enter Email"
              type="email"
              value={motherEmail}
              onChange={(e) => setMotherEmail(e.target.value)}
            />
            <SaveAndCancel
              onSave={() => console.log("Saved Mother")}
              onCancel={() => console.log("Cancelled Mother")}
            />
          </SectionBox>
        </div>
      </div>
    </div>
  );
};

// Reusable Section Container with Header
const SectionBox = ({ icon, heading, children }) => (
  <div className={styles.sectionBox}>
    <div className={styles.sectionShell}>
      <div className={styles.sectionHeaderBox}>
        <HeadingAndIcon icon={icon} heading={heading} />
      </div>
      <div className={styles.inputCard}>{children}</div>
    </div>
  </div>
);

export default AddEnquiry;
